<lsl-exercise-exam-result [isExam]="isExam" [quizSessionScore]="quizSessionScore"></lsl-exercise-exam-result>
<div class="buttons-container">
  @if (replayable) {
    <button (click)="handleRestartExercise()" class="btn basic w-md h-lg">
      <span inlineSVG="/icons/icon_refresh.svg"></span><span>{{ 'exercises.restart_exercise' | transloco }}</span>
    </button>
  }
  <button (click)="handleContinueClick()" routerLinkActive="router-link-active" class="btn primary w-md h-lg">
    {{ 'exercises.continue' | transloco }}
  </button>
</div>
